// Use a safe theme hook that works outside ThemeProvider too
import { useContext } from "react";

function useSafeTheme() {
 try {
 // Dynamic import to avoid circular deps
 const stored = typeof window !== "undefined" ? localStorage.getItem("ampa-theme-preference") : null;
 return { theme: stored === "light" ? "light" : "dark" };
 } catch {
 return { theme: "dark" };
 }
}
import { Toaster as Sonner, toast } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
 const { theme } = useSafeTheme()

 return (
 <Sonner
 theme={theme as ToasterProps["theme"]}
 className="toaster group"
 toastOptions={{
 classNames: {
 toast:
 "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
 description: "group-[.toast]:text-muted-foreground",
 actionButton:
 "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
 cancelButton:
 "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
 },
 }}
 {...props}
 />
 )
}

export { Toaster, toast }
